import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "@/app/features/auth/authSlice";
import Roles from "@/constants/roles";

/**
 * ProtectedRoute component that restricts access based on user role
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if access is allowed
 * @param {string[]} props.allowedRoles - Array of roles that can access this route
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const user = useSelector(selectUser);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to dashboard if user doesn't have required role
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;



